import Vue from "vue";
import Vuex from "vuex";
import {
	fetchLooks,
	fetchLayouts,
	fetchSizes,
	createCustomer,
	fetchRenders,
} from "@/network/project.service";

Vue.use(Vuex);

const initialState = () => ({
	looks: [],
	layouts: [],
	selectedLayout: null,
	sizes: [],
	selectedSize: null,
	selectedLook: null,
	renders: [],
	cuboids: [],
	isPanoViewerVisible: false,
	showCustomizationPopup: false,
});

const defaultGetters = function () {
	return Object.keys(initialState()).reduce((acc, cv) => {
		acc[cv] = (state) => state[cv];
		return acc;
	}, {});
};

const defaultMutations = function () {
	return Object.keys(initialState()).reduce((acc, cv) => {
		let splitCV = cv.split("");
		splitCV[0] = splitCV[0].toUpperCase();
		acc["set" + splitCV.join("")] = (state, data) => (state[cv] = data);
		return acc;
	}, {});
};

export default new Vuex.Store({
	state: initialState(),
	getters: {
		...defaultGetters(),
	},
	mutations: {
		...defaultMutations(),
	},
	actions: {
		async fetchLooks({ commit, dispatch, state }, id = "") {
			let res = await fetchLooks(id);

			if (
				res.status == 200 &&
				res.data &&
				res.data.data &&
				res.data.data.length > 0
			) {
				commit("setLooks", res.data.data);
				commit("setSelectedLook", res.data.data[0]);
				dispatch("fetchLayouts", {
					roomType: res.data.data[0].roomType,
				});
				if (state.selectedLook && state.selectedLook["panoramaImage"]) {
					commit("setCuboids", [state.selectedLook["panoramaImage"]]);
				} else {
					commit("setCuboids", []);
				}
			}
		},
		async fetchLayouts(
			{ commit, dispatch },
			{ id = "", roomType = "bEDROOM" } = {}
		) {
			let res = await fetchLayouts(id, roomType);

			if (
				res.status == 200 &&
				res.data &&
				res.data.data &&
				res.data.data.length > 0
			) {
				commit("setLayouts", res.data.data);
				commit("setSelectedLayout", res.data.data[0]);
				dispatch("fetchSizes", res.data.data[0]._id);
			}
		},
		async fetchSizes({ commit }, id = "") {
			let res = await fetchSizes(id);

			if (
				res.status == 200 &&
				res.data &&
				res.data.data &&
				res.data.data.length > 0
			) {
				commit("setSizes", res.data.data);
			}
		},
		async createCustomer(ctx, payload) {
			let res = await createCustomer(payload);

			if (res.status == 200 && res.data && res.data.ok) {
				return res;
			}
		},
		async fetchRenders(
			{ commit, state },
			{ lookId, layoutId, sizeId, sizeString }
		) {
			let res = await fetchRenders({
				lookId,
				layoutId,
				sizeId,
				sizeString,
			});

			if (res.status == 200 && res.data && res.data.data) {
				if (
					res.data.data.imageUrls &&
					res.data.data.imageUrls.length > 0
				) {
					commit("setRenders", res.data.data.imageUrls || []);
				} else {
					commit("setRenders", []);
				}
				if (
					res.data.data.cuboidUrls &&
					res.data.data.cuboidUrls.length > 0
				) {
					commit("setCuboids", res.data.data.cuboidUrls || []);
				} else {
					commit("setCuboids", []);
				}
			}

			if (
				state.cuboids.length === 0 &&
				state.selectedLook &&
				state.selectedLook["panoramaImage"]
			) {
				commit("setCuboids", [state.selectedLook["panoramaImage"]]);
			}

			if (
				state.renders.length === 0 &&
				state.selectedLook &&
				state.selectedLook["thumbnail"]
			) {
				commit("setRenders", [state.selectedLook["thumbnail"]]);
			}
		},
	},
	modules: {},
});
